angular.module('unergie.main')
.controller('wikiCtrl', ($scope, $state, $sce, content, BoFeaturesService) => {
    $scope.isActive = (state) => $state.is(state)

    $scope.title = content != null ? content.title : undefined
    let html = __guard__(__guard__(content != null ? content.body : undefined, (x1) => x1.view), (x) => x.value)
    if (!html) {
        $scope.title = content.results[0] != null ? content.results[0].title : $scope.title
        html = __guard__(__guard__(content.results[0] != null ? content.results[0].body : undefined, (x3) => x3.view), (x2) => x2.value.replace(/https:\/\/unergie.atlassian.net\/wiki\/download\/attachments\//g, '/confluence-attachments/'))
    }
    $scope.content = $sce.trustAsHtml(html)
})

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
